import React, { useEffect, useState } from "react";
import { AppConstant } from "../../../Assests/AppConstant";

const CustomTimePicker = ({ timeFormat = "12h",title,required=false,onChange,name,showError, value}) => {
  const [hours, setHours] = useState(null);
  const [minutes, setMinutes] = useState(null);
  const [amPm, setAmPm] = useState("AM");
  
  useEffect(() => {
    if (value) {
      const fTime = value.split(/:/).map(Number)
      setHours(fTime[0]);
      setMinutes(fTime[1]);
    }
  },[])

  useEffect(()=>{
    if (timeFormat==="12h") {
        if (hours!==null,minutes!=null,amPm) {
            onChange(formatTimeValue(hours,minutes,amPm),name)
        }
    }else{
        if (hours!=null,minutes!=null) {
            onChange(formatTimeValue(hours,minutes,amPm),name)
        }
    }
  },[hours,minutes,amPm])

  const generateHours = () => {
    if (timeFormat === "12h") {
      return Array.from({ length: 12 }, (_, i) => i + 1); 
    } else {
      return Array.from({ length: 24 }, (_, i) => i);
    }
  };

  const generateMinutes = () => {
    return Array.from({ length: 60 }, (_, i) => i);
  };

  const handleHourChange = (e) => {
    setHours(parseInt(e.target.value, 10));
  };

  const handleMinuteChange = (e) => {
    setMinutes(parseInt(e.target.value, 10));
  };

  const handleAmPmChange = (e) => {
    setAmPm(e.target.value);
  };

  const formatNumber = (num) => {
    return num < 10 ? `0${num}` : num;
  };

  const formatTimeValue = (hours, minutes, amPm) => {
    const formattedHours = formatNumber(hours);
    const formattedMinutes = formatNumber(minutes);

    if (timeFormat === "12h") {
      return `${formattedHours}:${formattedMinutes} ${amPm}`;
    } else {
      return `${formattedHours}:${formattedMinutes}`;
    }
  };

  return (
    <div className="f-14 fw-bold">
      {title && <p>Select Time</p>}
      <div className="d-flex gap-1">
        <div className="w-100">
        <label>Hours: &nbsp;{required && <span className="color-red">*</span>}</label>
        <select value={hours} onChange={handleHourChange} className="customTextInput">
        <option >Select Hour</option>
          {generateHours().map((hour) => (
            <option key={hour} value={hour}>
              {formatNumber(hour)}
            </option>
          ))}
        </select>
      </div>

      <div className="w-100">
        <label>Minutes: &nbsp;{required && <span className="color-red">*</span>}</label>
        <select value={minutes} onChange={handleMinuteChange} className="customTextInput">
        <option >Select Minutes</option>
          {generateMinutes().map((minute) => (
            <option key={minute} value={minute}>
              {minute < 10 ? `0${minute}` : minute}
            </option>
          ))}
        </select>
      </div>

      {timeFormat === "12h" && (
        <div className="w-100">
          <label >AM/PM: &nbsp;{required && <span className="color-red">*</span>}</label>
          <select value={amPm} onChange={handleAmPmChange} className="customTextInput">
            <option value="AM">AM</option>
            <option value="PM">PM</option>
          </select>
        </div>
      )}
</div>
      {
                     showError && (
                         <span className="errorMessage" data-testid={AppConstant.dataTestId.validationError}>
                             {showError ? showError : ''}
                         </span>
                     )
                 }
    </div>
  );
};

export default CustomTimePicker;